export default "__VITE_ASSET__445a8dbb__"